//App.js

export const ALTERATION_API = "https://rmapi.geseme.com/api/alteration";
// export const ALTERATION_API = "http://127.0.0.1:7202/api/alteration";
export const USERS_API = "https://rmapi.geseme.com/api/user";



// WEBPACK FOOTER //
// ./src/constants.js